import axios from "axios";
import { BASE_URL } from "../Config/globalParams";

//retourner les données d'agent
export const getMyAgentProfile = (tenant, userId, token)  => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/MyAgentProfile/${tenant}/${userId}?token=${token}`;
    axios.get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération du profil d'agent :`, error);
        resolve({}); 
      });
  });
};
  // retourner les scopes
  export const getScopes = (tenant,token)  => {
    return new Promise((resolve) => {
      const url = `${BASE_URL}/ScopeManagement/${tenant}/get/ALL?token=${token}`;
      axios.get(url)
        .then((response) => {
          
          resolve(response.data); 
        })
        .catch((error) => {
          console.error(`Erreur lors de la récupération des scopes :`, error);
          resolve({}); 
        });
    });
  };

//retourner les groupes
export const getGroups = (tenant, scope, groupId, userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/GroupManagement/${tenant}/${scope}/get/${groupId}?userid=${userId}`;
    axios.get(url)
      .then((response) => {
        
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des groups :`, error);
        resolve([]) ;
      });
  });
};

//retourner les callFlows
export const getCallFlows = (tenant, scope,userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/CallFlowManagement/${tenant}/${scope}/get/ALL?userid=${userId}`;
    axios.get(url)
      .then((response) => {
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des flux d'appels :`, error);
        resolve({});
      });
  });
};

// Service pour récupérer le profil d'un agent
export const getAgentProfile = (tenantId, scope, agentId, userId, groupId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/AgentManagement/${tenantId}/${scope}/get/${agentId}?userid=${userId}&groupid=${groupId}`;

    axios.get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération du profil de l'agent :`, error);
        resolve({}); 
      });
  });
};
// Service pour récupérer les infos de recording
export const retrieveCallRecordingInfo = (tenantId, filters) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/ManageRecordedCallCDR/${tenantId}/get`;
    axios.post(url, {filters })
      .then((response) => {
        resolve(response.data);
    
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des informations d'enregistrement :", error);
        resolve();
      });
  });
};



//service retrieve call Recording
export const retrieveCallRecordingUrl = (tenantId, recordingScopeId, callId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/BlobSasGenerator/${tenantId}/${recordingScopeId}/${callId}`;

    axios.get(url)
      .then((response) => {
        if (response.data && response.data.sasUrl) {
          resolve(response.data.sasUrl);
        } else {
          resolve(null);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération du SAS URL :", error);
        resolve();
      });
  });
};

// Service pour récupérer l' accessToken d'un agent pour accéder à un blob
export const getBlobAccessToken = (tenantId, agentScope, recordingScope, userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/Callrecordingsaccess/${tenantId}/${agentScope}/${recordingScope}?userid=${userId}`;
    axios.get(url)
      .then((response) => {
        resolve(response.data);
        })
      .catch((error) => {
        console.error("Erreur lors de l'accès au token du blob :", error);
        resolve(); 
      });
  });
};

